import React from "react"
import PropTypes from "prop-types"
import { OverlayPanel } from "../../../components/atoms/OverlayPanel.atom"
import {
  EVENT_TYPES,
  VACATION_STATES,
  VACATION_STATUS_CHIP_VARIANTS,
} from "../../../consts/modules/vacations.consts"
import VacationStatusChip from "../../../components/molecules/VacationStatusChip.molecule"
import {
  getVacationState,
  getVacationTooltip,
  vacationEventHasNotification,
} from "../../../utils/vacation.utils"

const GroupedEventsOverlayPanel = ({
  opRef,
  vacationRequests = [],
  clickedEvent,
  handleEventClick = () => {},
  containerSelector = ".calendar-card-container",
}) => {
  return (
    <OverlayPanel
      ref={opRef}
      showCloseIcon
      dismissable={false}
      appendTo={document?.querySelector(containerSelector)}
    >
      <table className="grouped-vacations-popup">
        <tbody>
          {clickedEvent?.groupedEvents?.map((e, idx) => (
            <tr
              key={idx}
              className="row"
              onClick={(clickEvent) =>
                handleEventClick(e, clickEvent, {
                  groupedEvents: false,
                })
              }
            >
              <td>{e.title}</td>
              <td>
                <VacationStatusChip
                  key={idx}
                  status={getVacationState(e)}
                  notification={vacationEventHasNotification(e)}
                  variant={VACATION_STATUS_CHIP_VARIANTS.LONG}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </OverlayPanel>
  )
}

export default GroupedEventsOverlayPanel

const isEventOnClickedDay = (event, clickedDay) =>
  clickedDay >= event.start &&
  clickedDay <= event.end &&
  event.eventType !== EVENT_TYPES.HOLIDAY &&
  !("holidayTypeId" in event)

GroupedEventsOverlayPanel.propTypes = {
  opRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  vacationRequests: PropTypes.array,
  clickedDay: PropTypes.instanceOf(Date),
  handleEventClick: PropTypes.func,
  containerSelector: PropTypes.string,
}
